import {Component, OnInit, Inject, OnDestroy, ViewChild} from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslationService } from "../../services/translation.service";
import { EventService } from "../../services/event.service";
import { DatePipe } from "@angular/common";
import { SessionLoginService } from "../../../core/services/session-login.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {catchError} from "rxjs/operators";
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from "@angular/material/snack-bar";
import {of} from "rxjs";




@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss']
})
export class EventFormComponent implements OnInit, OnDestroy {
  availableLanguages: string[] = [];
  form: { [key: string]: FormGroup } = {};
  smallImageFile: File | null = null;
  largeImageFile: File | null = null;
  id: any | null = null;
  force = false;
  isLoading = false;

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  selectedDate!: string;

  constructor(
    public translate: TranslateService,
    public dialog: MatDialog,
    public translationService: TranslationService,
    private eventService: EventService,
    private datePipe: DatePipe,
    public session: SessionLoginService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EventFormComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { id: any | null }
  ) {
    const currentDate = new Date();
    this.selectedDate = this.formatDate(currentDate);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;  // Format YYYY-MM-DD
  }

  onTouchMove(event: TouchEvent): void {
    // Logique pour gérer l'événement touchmove
    console.log('Touch move detected', event);
  }

  onTouchStart(event: TouchEvent): void {

  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    document.addEventListener('touchstart', this.onTouchStart, { passive: true });
    document.addEventListener('touchmove', this.onTouchMove, { passive: true });

    if (this.data?.id) {
      this.id = this.data.id;
      this.isLoading = true;

      this.eventService.getEvent(this.id).subscribe(event => {
        this.loadEventData(event);
      });
    }

    let lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.translate.use(lang);
    }

    this.availableLanguages = this.translationService.getAvailableLanguages();

    this.availableLanguages.forEach(lang => {
      this.form[lang] = this.fb.group({
        title: ['', Validators.required],
        short_description: ['', Validators.required],
        content: [''],
      });
    });
  }

  loadEventData(event: any): void {

    this.isLoading = false;
    this.availableLanguages.forEach(lang => {
      const formGroup = this.form[lang];

      const translation = event.translations.find((t: any) => t.locale === lang);

      if (translation) {
        formGroup.patchValue({
          title: translation.title || event.title,
          short_description: translation.short_description || event.short_description,
          content: translation.content || event.content
        });
      } else {

        formGroup.patchValue({
          title: event.title,
          short_description: event.short_description,
          content: event.content
        });
      }
    });

    if(event.smallImageUrl) {
      this.smallImageFile = event.smallImageUrl || null;
    }


    if(event.largeImageUrl) {
      this.largeImageFile = event.largeImageUrl || null;
    }
  }

  isFormValid(): boolean {
    return this.availableLanguages.every(lang => this.form[lang]?.valid);
  }

  onFileChange(event: Event, type: 'small' | 'large'): void {
    const file = (event.target as HTMLInputElement).files?.[0] || null;
    if (type === 'small') {
      this.smallImageFile = file;
    } else {
      this.largeImageFile = file;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (!this.isFormValid()) return;

    const formData = new FormData();

    if (this.smallImageFile && !(typeof this.smallImageFile === 'string')) {
      formData.append('small_image', this.smallImageFile);
    }

    if (this.largeImageFile && !(typeof this.largeImageFile === 'string')) {
      formData.append('large_image', this.largeImageFile);
    }


    if (this.id) {
      formData.append('id', this.id);
    }


    if (this.force) {
      formData.append('force', 'true');
    }

    if (this.selectedDate) {
      formData.append('date', this.selectedDate);
    }


    this.availableLanguages.forEach(lang => {
      const formGroup = this.form[lang];
      formData.append(`translations[${lang}][title]`, formGroup.value.title);
      formData.append(`translations[${lang}][short_description]`, formGroup.value.short_description);
      formData.append(`translations[${lang}][content]`, formGroup.value.content);
    });

    this.isLoading = true;
    this.eventService.createOrUpdate(formData).subscribe(response => {
      this.isLoading = false;
      this.dialogRef.close('updated');
    });
  }

  generateWithIa(): void {
    const formData = new FormData();

    const firstLang = this.availableLanguages[0];

    const formGroup = this.form[firstLang];

    formData.append(`translations[${firstLang}][title]`, formGroup.value.title);
    formData.append(`translations[${firstLang}][short_description]`, formGroup.value.short_description);
    formData.append(`translations[${firstLang}][content]`, formGroup.value.content);
    this.isLoading = true;

    this.eventService.generateWithIa(formData).subscribe(response => {

      const translations = response.translations;

      this.availableLanguages.forEach(lang => {

        this.isLoading = false;

        const translation = translations[lang];
        if (translation) {
          const formGroup = this.form[lang];
          formGroup.patchValue({
            title: translation.title || '',
            short_description: translation.short_description || '',
            content: translation.content || ''
          });
        }
      });
    });
  }

  deleteEvent(): void {
    const eventId = this.id;

    if (eventId) {
      // Confirmer la suppression
      const confirmDelete = confirm('Are you sure you want to delete this event?');

      if (confirmDelete) {
        this.isLoading = true;

        // Appeler la méthode du service pour supprimer l'événement
        this.eventService.deleteEvent(eventId)
          .pipe(
            catchError(error => {
              // Gérer l'erreur si la suppression échoue
              this.isLoading = false;
              console.error('Error deleting event:', error);
              this._snackBar.open('Failed to delete event', '', {
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
                duration: 2000
              });
              return of(null);
            })
          )
          .subscribe(response => {
            if (response) {
              // Afficher le message de succès
              this.isLoading = false;
              this._snackBar.open('Event deleted successfully!', '', {
                horizontalPosition: this.horizontalPosition,
                verticalPosition: this.verticalPosition,
                duration: 2000
              });

              this.dialogRef.close('deleted');
            }
          });
      }
    } else {
      this.isLoading = false;
      console.log('Event ID is missing.');
    }
  }

  changeDate(event: any): void {
    const selectedDate = event.target.value; // Récupère la nouvelle valeur de la date
    console.log('Selected Date:', selectedDate);

    // Si vous avez besoin de mettre à jour la valeur du FormControl
    this.selectedDate = selectedDate;
  }

  setForceOrNot() {
  }
}
